
export default {
  name: 'PermanentPromotionLayout'
}
